import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch, useParams } from "react-router-dom";
import { getBaseUrl } from "services/util";

import { initiatePPTUpload, updatePPTUploadProgress, createStoryboardFromPPT } from 'actions/storyboard';

import cx from 'classnames';
import shortid from 'shortid';
import _ from "lodash";

import { Button, Form, Offcanvas } from 'react-bootstrap';

import S3Upload from 'react-s3-uploader/s3upload'
import AuthService from 'services/auth.service';

import styles from './pptxButton.module.scss';
import { FailureToast } from 'components/Toast';
import { toast } from 'react-toastify';

const API_URL = `${process.env.REACT_APP_PAPERFLITE_API_URL}/api/2.0`;

export function PPTXButton({ className, onClose, type, setPptState, setCreateState, storyboardState, setStoryboardState, createDirectly }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { url } = useRouteMatch();
  const baseUrl = getBaseUrl(url);
  const { listId } = useParams();
  const promptBasedEditorEnabled = useSelector(state => _.get(state, 'workspaces.workspace.item.promptBasedEditorEnabled', false));

  useEffect(() => {
      setPptState((state) => {
        return {
          ...state,
          pptFile: null
        }
      })
  }, []);

  const onDiscard = () => {
    setPptState({});
  }

  const handleUploadProgress = handlePptUploadProgress(dispatch);

  const handleUploadComplete = handlePptUploadComplete(storyboardState, dispatch);

  const handleFileCheck = handlePptFileCheck();

  const handleFileChange = (e) => {
    var file = e.target.files[0];

    if(!file || !file.name.endsWith(".pptx")) {
      toast(
          <FailureToast
            heading={`Failure`}
            description={`File not supported.`}
          />,
          {
            type: toast.TYPE.DEFAULT,
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          }
        );

      return;
    }

    file.id = shortid();

    if (!createDirectly) {
      setPptState((state) => {
        return {
          ...state,
          pptFile: file,
          showPPTModal: true
        }
      })
    }

    if (createDirectly) {
      const uploadFunction = handlePptFileUpload(
        storyboardState,
        handleFileCheck,
        handleUploadComplete,
        handleUploadProgress,
        file,
        dispatch,
        onDiscard
      );
      uploadFunction(); 
    }

    setCreateState((state) => {
      return {
        ...state,
        create: false,
        delete: null
      };
    });

    setStoryboardState({
      content: null,
      storyboardName: ''
    });

    e.target.value = '';
    
    if (promptBasedEditorEnabled){
      const url = listId
        ? `${baseUrl}/storyboards/folder/${listId}`
        : `${baseUrl}/storyboards`;
      history.push(url); 
    }
  }

  return (
    <>
      <div className={cx(styles.fileUpload, className)}>
        <input 
          type="file" 
          title=''
          name="Import PPT"
          accept='.pptx'
          multiple={false}
          onClick={(e) => e.stopPropagation()} 
          onChange={handleFileChange}
        />
        <span className={styles.importPPT}>
          <i className={cx('cleverstory-pptx')} />
          <span>PPT</span>
        </span>
      </div>
    </>
  )
}

export const ChoosePPTContentTypePanel = ({show, onDiscard, resetAllModals, pptFile}) => {
  const dispatch = useDispatch();

  const subscription = useSelector(state => _.get(state, 'workspaces.workspace.item.subscription'));

  const [storyboardState, setStoryboardState] = useState({
    content: null,
    storyboardName: ''
  })

  const contentId = _.get(storyboardState.content, 'id', null);

  const removeSpecialCharactersFromName = (name) => {
    return name
      .replace(/\u202F/g, '')
      .replace('.pptx', '');
  };

  const fileName = removeSpecialCharactersFromName(_.get(pptFile, 'name', 'Untitled'));

  const contentTypes = [
    { 
      id: 'blank_interactive_template_v2',
      type: "INTERACTIVE_CONTENT_V2",
      label: "Interactive Content",
      image: "/images/interactive.svg",
      active: "/images/interactive_active.svg",
      className: "interactiveImg",
      enabled: _.get(subscription, 'interactiveContentEnabled', false)
    },
    { 
      id: 'blank_spatial_template',
      type: "SPATIAL",
      label: "Spatial",
      image: "/images/spatial.svg",
      active: "/images/spatial_active.svg",
      className: "interactiveImg",
      enabled: _.get(subscription, 'spatialEnabled', false)
    },
  ];

  useEffect(() => {
    setStoryboardState((state) => {
      return {
        ...state,
        storyboardName: fileName || ''
      }
    })
  }, [fileName]);

  useEffect(() => {
    if(!show){
      setStoryboardState((state) => {
        return {
          ...state,
          storyboardName: fileName || '',
          content: null
        }
      })
    }
  },[show])

  const onNameChange = (e) => {
    const { value } = e.target;
    setStoryboardState((state) => {
      return {
        ...state,
        storyboardName: value,
      }
    })
  }
  const handleUploadProgress = handlePptUploadProgress(dispatch);

  const handleUploadComplete = handlePptUploadComplete(storyboardState, dispatch);

  const handleFileCheck = handlePptFileCheck();

  const handleUpload = handlePptFileUpload(storyboardState, handleFileCheck, handleUploadComplete, handleUploadProgress, pptFile, dispatch, onDiscard);



  return(
    <Offcanvas className={styles.chooseStoryboardPanel} show={show} onHide={onDiscard} backdropClassName={styles.backdropFigmaContentType} 
      placement='start' backdrop="static"> 
        <div className={styles.createStoryboardPanel}>
          <Button className={styles.backButton} variant="info" onClick={onDiscard} >
            <i className={cx("cleverstory-close")} />
          </Button>
          <header className={styles.header}>
            <h1 className={styles.title}>Choose a content type</h1>
            <span className={styles.description}>Select a content type to create a storyboard effortlessly with your PPT file.</span>
          </header>
          <div className={styles.blankTemplate}>
            <div className={styles.customContainer}>
                <h6 className={styles.typesTitle}>TITLE</h6>
                <Form.Control
                  value={storyboardState.storyboardName}
                  onChange={onNameChange}
                  className={styles.name}
                  placeholder="Storyboard name"
                  data-track-event="Mixpanel" data-track-props="Title in Template"
                />
            </div>

            <div className={styles.customContainer}> 
                <h6 className={styles.typesTitle}>CONTENT TYPE</h6>     
                <div className={styles.storyBoardFormat} >

                {(contentTypes || []).map((option)=> {
                    return(
                      <>
                      {option.enabled &&
                        <Button variant="info" className={cx(styles.scratchTemplate, { [styles.activeBtn]: _.get(storyboardState.content, 'type', '') === option.type })} 
                        onClick={() => setStoryboardState((state) => {
                          return {
                            ...state,
                            content: option,
                          }
                        })}
                        >
                          <div className={styles.imgBox}>
                            <img className={styles[option.className]} src={_.get(storyboardState.content, 'type', '') === option.type ? option.active : option.image} />
                          </div>
                          <div className={styles.titleBox}>
                            <span>{option.label}</span>
                          </div>
                        </Button>
                      }
                      </>
                    )
                  })
                }
                </div>
            </div>
            
            <div className={styles.actionContainer}>
              <Button onClick={handleUpload} className={styles.saveButton} variant="primary" disabled={!storyboardState.storyboardName?.trim() || !contentId}>
                Continue
              </Button>
              <Button onClick={onDiscard} className={styles.saveButton} variant="secondary" >
                Cancel
              </Button>
            </div>
      
          </div>
        </div>
    </Offcanvas>
  )
}

function handlePptFileCheck() {
  return (file, next) => {

    const fileSizeExceeded = (file.size / 1048576) > 15;

    if (file.type === 'video/mp4' && fileSizeExceeded) {
      console.log('video size is maximum');
    } else {
      next(file);
    }
  };
}

function handlePptUploadComplete(storyboardState, dispatch) {
  return (info, file) => {
    if (info) {
      const contentType = _.get(storyboardState.content, 'id', null);

      const request = {
        name: storyboardState.storyboardName,
        signedUrl: info.signedUrl,
        storyboardTemplate: contentType
      };


      dispatch(createStoryboardFromPPT(file.id, request));
    }
  };
}

function handlePptUploadProgress(dispatch) {
  return (progress, textState, file) => {
    dispatch(updatePPTUploadProgress(file.id, progress));
  };
}

function handlePptFileUpload(storyboardState, handleFileCheck, handleUploadComplete, handleUploadProgress, pptFile, dispatch, onDiscard) {
  return () => {

    var s3Uploader = new S3Upload({
      signingUrl: "/file_upload/initiate",
      signingUrlMethod: "POST",
      signingUrlHeaders: {
        Authorization: `Bearer ${AuthService.getAccessToken()}`
      },
      server: API_URL,
      scrubFilename: (filename) => {
        var name = storyboardState.storyboardName;
        name = name.replace(/[^\w\d_\-.\s]+/ig, '');
        return name;
      },
      signingUrlQueryParams: { 'originalName': encodeURIComponent(storyboardState.storyboardName) },
      contentDisposition: 'auto',
      preprocess: handleFileCheck,
      uploadRequestHeaders: {},
      onFinishS3Put: handleUploadComplete,
      onProgress: handleUploadProgress,
      files: [pptFile]
    });

    const upload = {
      id: s3Uploader.files[0].id,
      name: storyboardState.storyboardName,
      type: s3Uploader.files[0].type,
      size: (s3Uploader.files[0].size / 1048576),
      progress: 0,
      instance: s3Uploader,
      storyboardType: _.get(storyboardState.content, 'label', null)
    };

    dispatch(initiatePPTUpload(upload));

    onDiscard();
  };
}
